import { ELabelView } from "../components/View/ELabelView";
export const ELABEL_VIEW = {
    path: "/qr/:qrIndicator",
    component: ELabelView,
};
